import { Clock, Check, FileText, Video, Edit3, Image, CheckCircle2, Youtube, Instagram, Linkedin } from 'lucide-react';
import { TikTok } from '../components/icons/TikTok';

export const STAGES = [
  { id: 'pending_approval', label: 'Pending Approval', color: 'bg-amber-100', text: 'text-amber-700', icon: Clock },
  { id: 'approved', label: 'Approved', color: 'bg-green-100', text: 'text-green-700', icon: Check },
  { id: 'scripting', label: 'Scripting', color: 'bg-blue-100', text: 'text-blue-700', icon: FileText },
  { id: 'recording', label: 'To Record', color: 'bg-purple-100', text: 'text-purple-700', icon: Video },
  { id: 'editing', label: 'Editing', color: 'bg-orange-100', text: 'text-orange-700', icon: Edit3 },
  { id: 'thumbnail', label: 'Thumbnail', color: 'bg-pink-100', text: 'text-pink-700', icon: Image },
  { id: 'scheduled', label: 'Scheduled', color: 'bg-indigo-100', text: 'text-indigo-700', icon: Clock },
  { id: 'published', label: 'Published', color: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle2, canClear: true },
];

export const PLATFORMS = [
  { id: 'youtube', label: 'YT', full: 'YouTube', icon: Youtube, color: 'text-red-500', bg: 'bg-red-100' },
  { id: 'tiktok', label: 'TT', full: 'TikTok', icon: TikTok, color: 'text-gray-900', bg: 'bg-gray-100' },
  { id: 'instagram', label: 'IG', full: 'Instagram', icon: Instagram, color: 'text-pink-500', bg: 'bg-pink-100' },
  { id: 'linkedin', label: 'LI', full: 'LinkedIn', icon: Linkedin, color: 'text-blue-600', bg: 'bg-blue-100' },
];

export const TYPES = ['Long-form', 'Short-form', 'Carousel', 'LinkedIn Post'];
export const CUTDOWN_STATUS = ['pending', 'editing', 'done'];
export const USERS = ['zein', 'mo'];
